<template>
    <div class="clearfix" style="position: relative; padding: 10px 15px;">
        <Table :columns="columns" :data="dataList" size="small" style="margin-bottom: 20px;"></Table>
        <div class="button-container pull-right">
            <Button class="margin-right-15" type="primary" @click="submit">确定</Button>
            <Button type="default" @click="$emit('on-close')">返回</Button>
        </div>
        <Spin v-if="loading" fix></Spin>
    </div>
</template>

<script>
import {
    HttpGetEditServiceData,
    HttpEditServiceData
} from "@/service/carrieraccount.js";
export default {
    props: ['id'],
    data () {
        return {
            loading: false,
            dataList: []
        }
    },
    created () {
        this.loading = true;
        HttpGetEditServiceData({
            id: this.id
        }).then(res => {
            // this.$VMessage.success(res.message);
            console.log(res.data);
            this.dataList = res.data;
        }, err => {
            this.$VMessage.error(err.message);
        }).finally(() => {
            this.loading = false;
        });
    },
    computed: {
        columns () {
            return [
                {
                    title: '承运商服务',
                    key: 'carrierServiceCode'
                },
                {
                    title: '物流服务代码',
                    key: 'code'
                },
                {
                    title: '体积重系数',
                    render: (h, { row, index }) => {
                        return h('InputNumber', {
                            style: {
                                'width': '100%'
                            },
                            props: {
                                value: row.volumeWeight ? row.volumeWeight : null,
                                size: 'small',
                                min: 0
                            },
                            on: {
                                'on-change': (val) => {
                                    this.dataList[index].volumeWeight = val;
                                }
                            }
                        })
                    }
                }
            ]
        }
    },
    methods: {
        async submit () {
            let items =  this.dataList.filter(item => {
                console.log(item.volumeWeight)
                return item.volumeWeight == 0 || (item.volumeWeight != null && item.volumeWeight != '');
            });
            if (!items.length) return this.$emit('on-close');
            await HttpEditServiceData({
                id: this.id,
                items: items.map(item => {
                    return {
                        carrierServiceId: item.id,
                        name: item.carrierServiceCode,
                        carrierVolumeWeight: item.volumeWeight
                    }
                })
            }).then(res => {
                this.$VMessage.success(res.message);
                this.$emit('on-close');
                this.$emit('on-update');
            }, err => {
                this.$VMessage.error(err.message);
            }).finally(() => {
                this.loading = false;
            });
        }
    }
}
</script>

<style>

</style>